import { create } from 'zustand'

export type ExpandedState = {
  expandedSet: Set<string>
}

const defaultExpandedState: ExpandedState = {
  expandedSet: new Set(),
}

type ExpandedActions = {
  add: (id: string) => void
  isExpanded: (id: string) => boolean
  toggleExpanded: (id: string) => void
}

export const useExpandedStore = create<ExpandedState & ExpandedActions>()((set, get) => ({
  ...defaultExpandedState,
  add: id =>
    set(state => {
      const newSet = new Set(state.expandedSet)
      newSet.add(id)
      return { expandedSet: newSet }
    }),
  isExpanded: id => get().expandedSet.has(id),
  toggleExpanded: id =>
    set(state => {
      const newSet = new Set(state.expandedSet)
      if (!newSet.has(id)) return { expandedSet: newSet.add(id) }

      newSet.delete(id)
      return { expandedSet: newSet }
    }),
}))
